import { Component, ContentChild, EventEmitter, Input, OnInit, Optional, Output, Self, TemplateRef } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { IonicComponentsModule } from 'src/app/modules/ionic-components.module';
import { AlertService } from 'src/app/services/alert.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'fv-datefield-sistema',
  templateUrl: './datefield-sistema.component.html',
  styleUrls: ['./datefield-sistema.component.scss'],
  imports: [
    IonicComponentsModule
  ],
  standalone: true
})
export class DatefieldSistemaComponent implements ControlValueAccessor {

  //#region Propiedades

  @ContentChild("selectorTpl") public selectorTpl: TemplateRef<any>
  @Input("label") public label: string
  @Input("readonly") public readonly: boolean
  @Input("obligatorio") public obligatorio: boolean // Esto es solo para pintar un asterisco, y este campo no se lee de los validadores, sino que hay que establecerlo a mano

  private _value: string
  public get value(): string {
    return this._value
  }
  @Input("value") public set value(val: string) {
    this._value = val
  }
  @Output("valueChange") public valueChange = new EventEmitter<string>()
  @Output("valueSelected") public valueSelected = new EventEmitter<{newValue: string, oldValue: string}>()

  //#endregion

  //#region Constructor

  constructor(
    private util: UtilService,
    private alert: AlertService,
    @Self() @Optional() private control: NgControl
  ) {
    this.control.valueAccessor = this
  }

  //#endregion

  //#region Eventos

  public async setCurrentDate(): Promise<void> {
    if (this.readonly) return
    if (await this.alert.showConfirm('¿Quieres establecer la fecha actual en este campo?', 'Establecer fecha', 'Sí, establecer', 'No, cancelar')) {
      let oldValue = this.value
      if (this.value != '') return // Solo se puede establecer la fecha si no está previamente establecida.
      let date: Date = new Date()
      this.value = this.util.DateToString(date)
      this.valueChange.emit(this.value)
      this.valueSelected.emit({newValue: this.value, oldValue: oldValue})
      this.onChange(this.value)
      this.onTouched()
    }
  }

  //#endregion

  //#region Reactive Forms

  private onChange = (value: string) => {}
  private onTouched = () => {}

  writeValue(value: string): void {
    this.value = value
    this.valueChange.emit(value)
    this.onChange(value)
  }

  registerOnChange(fn: (value: string) => {}): void{
    this.onChange = fn
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn
  }

  public isInvalid(): boolean {
    return this.control ? this.control.invalid : false
  }

  public isTouched(): boolean {
    return this.control ? this.control.touched : false
  }

  //#endregion

}
